/*
 * AIBuilder Messages
 *
 * This contains all the text for the AI builder component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.containers.AISurveyBuilder';

export default defineMessages({
  generalError: {
    id: `${scope}.generalError`,
    defaultMessage: `<div>Oops, looks like something went wrong 🥲</div>
    <div>Don't worry, we're on it! Try again in a moment or give it a refresh.</div>`,
  },
  welcomeAI: {
    id: `${scope}.welcomeAI`,
    defaultMessage: 'Welcome to AI builder',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading',
  },
  pickOne: {
    id: `${scope}.actions.pickOne`,
    defaultMessage: 'Pick one from the following options:',
  },
  aiMistakes: {
    id: `${scope}.actions.aiMistakes`,
    defaultMessage:
      'AI can make mistakes, please review the survey and changes carefully.',
  },
  noAIMessage: {
    id: `${scope}.noAIMessage`,
    defaultMessage: 'Done!',
  },
  undoTooltip: {
    id: `${scope}.undoTooltip`,
    defaultMessage: 'Undo latest AI changes',
  },
  positiveFeedbackTooltip: {
    id: `${scope}.positiveFeedbackTooltip`,
    defaultMessage: 'Like this response',
  },
  negativeFeedbackTooltip: {
    id: `${scope}.negativeFeedbackTooltip`,
    defaultMessage: 'Dislike this response',
  },
  submitFeedback: {
    id: `${scope}.submitFeedback`,
    defaultMessage: 'Submit feedback',
  },
  feedbackModalTitle: {
    id: `${scope}.feedbackModalTitle`,
    defaultMessage: 'Thank you for your feedback! Let us know what went wrong:',
  },
  feedbackResponses: {
    positiveFeedback1: {
      id: `${scope}.feedbackResponses.positiveFeedback1`,
      defaultMessage: 'Thank you for your feedback!',
    },
    positiveFeedback2: {
      id: `${scope}.feedbackResponses.positiveFeedback2`,
      defaultMessage: `We're glad that you liked it.`,
    },
    positiveFeedback3: {
      id: `${scope}.feedbackResponses.positiveFeedback3`,
      defaultMessage: 'We appreciate your feedback!',
    },
    positiveFeedback4: {
      id: `${scope}.feedbackResponses.positiveFeedback4`,
      defaultMessage: 'Big thanks for your feedback!',
    },
    positiveFeedback5: {
      id: `${scope}.feedbackResponses.positiveFeedback5`,
      defaultMessage: 'Your kind feedback made our day.',
    },
    negativeFeedback: {
      id: `${scope}.feedbackResponses.negativeFeedback`,
      defaultMessage: 'Thank you for your feedback!',
    },
    negativeFeedbackUserOption1: {
      id: `${scope}.feedbackResponses.negativeFeedbackUserOption1`,
      defaultMessage: `The response wasn't accurate`,
    },
    negativeFeedbackUserOption2: {
      id: `${scope}.feedbackResponses.negativeFeedbackUserOption2`,
      defaultMessage: `I don't like the tone`,
    },
    negativeFeedbackUserOption3: {
      id: `${scope}.feedbackResponses.negativeFeedbackUserOption3`,
      defaultMessage: `Didn't fully follow instructions`,
    },
    negativeFeedbackUserOptionOther: {
      id: `${scope}.feedbackResponses.negativeFeedbackUserOptionOther`,
      defaultMessage: `Other`,
    },
    negativeFeedbackUserOptionOtherPlaceholder: {
      id: `${scope}.feedbackResponses.negativeFeedbackUserOptionOtherPlaceholder`,
      defaultMessage: `Write your feedback here`,
    },
  },
});
